export default import.meta.ROLLDOWN_FILE_URL_8x5aDhPgUl28ynwFi6Wq7A